<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.order_code }}</div>
              <div class="t-status">加工单号</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventory_code }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>已备料数量：{{ v.received }}</p>
              <!-- <p class="red">待备料数量：{{ v.to_received }}</p> -->
              <p>加工总数：{{ v.total }}</p>
              <van-field
                v-model="v.position"
                @click="onSearchShow(v.id, v.warehouse_id, v.products_id)"
                readonly
                type="tel"
                label="备货仓位"
                placeholder="请选择备货仓库"
              />
              <van-field v-model="v.stnum" type="tel" label="备货数量" placeholder="请输入备货数量" />
            </div>
            <!-- <div class="st-list-bottom">
              <div class="st-opt-btn">
                确定出库
              </div>
            </div> -->
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">拆工单号</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventory_code }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>已备料数量：{{ v.received }}</p>
              <!-- <p class="red">待备料数量：{{ v.to_received }}</p> -->
              <p>拆工总数：{{ v.quantity }}</p>
              <van-field
                v-model="v.position"
                @click="onSearchShow(v.id, v.warehouse_id, v.products_id)"
                readonly
                type="tel"
                label="备货仓位"
                placeholder="请选择备货仓库"
              />
              <van-field v-model="v.stnum" type="tel" label="备货数量" placeholder="请输入备货数量" />
            </div>
            <!-- <div class="st-list-bottom">
              <div class="st-opt-btn">
                确定出库
              </div>
            </div> -->
          </div>
        </van-list>
      </div>
    </div>

    <div class="footer pf-btm">
      <div class="btn" @click="submit()">提交备货信息</div>
    </div>

    <van-popup v-model="searchShow" round position="bottom" :style="{ height: '90%', backgroundColor: '#f5f5f5' }">
      <van-search
        v-model="keyword"
        shape="round"
        placeholder="请输入仓位关键字"
        show-action
        @input="inputKeyWordHandle"
        @cancel="searchShow = false"
      />
      <van-cell-group>
        <div v-for="item in feedbackList" :key="item.id">
          <van-cell
            :title="'仓位:' + item.position"
            :value="'库存:' + item.stocknum"
            @click="selectWarehouseHandle(item.id, item.position)"
          />
        </div>
      </van-cell-group>
      <div class="loadingWrap">
        <van-loading v-if="keywordLoading" size="24px" vertical>加载中...</van-loading>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  onents: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["加工备料", "拆工备料"],
      cur: 0,
      status: 0,
      stlist0: [],
      stlist1: [],
      searchShow: false,
      keyword: "",
      activeId: "",
      warehouseId: "",
      productsId: "",
      feedbackList: [],
      keywordLoading: false,
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    get_st_list() {
      this.stlist0 = [];
      this.stlist1 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    // 设置nav高亮
    init() {
      let activeIndex = window.sessionStorage.getItem("material_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    // 分页
    async onLoad() {
      let e = sessionStorage.getItem("material_activeIndex");
      if (e == 1) {
        let result = await this.$post(this.$api.stGetChaigongLingliaoList, {
          order_code: this.order_code,
          status: this.cur,
          page: this.page,
          sku: this.sku,
        });

        if (result.data.length == 0) return (this.finished = true);

        // 进行操作
        let dataList = result.data.map((item) => {
          item.position = ""; // 仓位
          item.positionId = ""; // 仓位id
          item.stnum = ""; // 入库数量
          return item;
        });
        this["stlist" + this.cur].push(...dataList);
        // 操作完成
        this.page += 1;
        this.loading = false;
      } else {
        let result = await this.$post(this.$api.stGetJiagongLingliaoList, {
          order_code: this.order_code,
          status: this.cur,
          page: this.page,
          sku: this.sku,
        });

        if (result.data.length == 0) return (this.finished = true);
        // 进行操作
        let dataList = result.data.map((item) => {
          item.position = ""; // 仓位
          item.positionId = ""; // 仓位id
          item.stnum = ""; // 入库数量
          return item;
        });
        this["stlist" + this.cur].push(...dataList);
        // 操作完成
        this.page += 1;
        this.loading = false;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("material_activeIndex", value);
    },
    // async edit() {
    //   let apiUrl;
    //   if (this.cur == 0) {
    //     apiUrl = this.$api.stSetJiagongLingliaoDoedit;
    //   } else if (this.cur == 1) {
    //     apiUrl = this.$api.stSetChaigongLingliaoDoedit;
    //   }
    //   let result = await this.$post(apiUrl, {
    //     id: this.dialogActiveId,
    //     stnum: this.dialog_num,
    //   });
    //   if (result.code == 200) {
    //     this.$toast.success("提交成功");
    //     this.get_st_list(this.cur);
    //   }
    //   this.dialog_num = "";
    // },

    // 显示仓位搜索的回调
    onSearchShow(id, whId, pId) {
      console.log(arguments);
      this.keyword = "";
      this.feedbackList = [];
      this.activeId = id;
      this.productsId = pId;
      this.warehouseId = whId;
      this.searchShow = true;
    },
    // 根据关键字搜索仓位
    async inputKeyWordHandle(keyword) {
      if (keyword.trim() == "") return (this.feedbackList = []);
      this.keywordLoading = true;
      let result = await this.$post(this.$api.stGetFeedbackList, {
        keyword,
        warehouse_id: this.warehouseId,
        products_id: this.productsId,
      });
      this.keywordLoading = false;
      this.feedbackList = result.data;
    },
    // 选定仓位的回调
    selectWarehouseHandle(id, value) {
      console.log(this.activeId);
      this["stlist" + this.cur] = this["stlist" + this.cur].filter((item) => {
        if (item.id == this.activeId) {
          item.positionId = id;
          item.position = value;
        }
        return item;
      });
      this.searchShow = false;
    },
    // 过滤无效信息
    rulesSubmitForm(dataList) {
      return dataList.filter((item) => {
        if (item.positionId != "" && item.position !== "") {
          return item;
        }
      });
    },
    // 提交备货信息
    async submit() {
      let dataForm = this.rulesSubmitForm(this["stlist" + this.cur]);
      if (dataForm.length == 0) {
        return this.$toast.fail("暂无待入库数量或仓位");
      }
      let params = [];
      dataForm.map((item) => {
        let obj = {};
        obj.id = item.id;
        obj.stnum = item.stnum;
        obj.position_id = item.positionId;
        params.push(obj);
      });

      let result;
      if (this.cur == 0) {
        // 加工
        result = await this.$post(this.$api.stSetJiagongLingliaoDoedit, params);
      } else if (this.cur == 1) {
        // 拆工
        result = await this.$post(this.$api.stSetChaigongLingliaoDoedit, params);
      }

      this.$toast.success("提交成功");
      this.get_st_list();
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {
      // this.onSearch("");
    },
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "出库备料" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
.van-form .van-cell.van-field {
  padding: 10px 16px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.tab-tilte li {
  width: 50%;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 16px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm .btn {
  box-sizing: border-box;

  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
.van-cell.van-field {
  padding: 7px 0;
}
.loadingWrap {
  text-align: center;
}
</style>
